import { Controller } from "@hotwired/stimulus"

// Attached to a CP2020 role <select>. On change it announces the character's current
// role slug(s) so the skills editor can highlight the career (package) skills and
// materialize the role's Special Ability — which is now a skill row in the SPECIAL
// group (see SkillsCollection), not a sibling field this controller fills. The sheet
// form owns field access (see cp2020--sheet).
export default class extends Controller {
  static outlets = ["cp2020--sheet"]

  // Announce both slots' role slugs (window-level; the skills editor listens via
  // cp2020:roles-changed). Fires on every role change, including clears.
  broadcastRoles() {
    const slugs = this.hasCp2020SheetOutlet
      ? ["role_0", "role_1"].map((r) => this.cp2020SheetOutlet.field(r)).filter(Boolean)
      : []
    this.dispatch("roles-changed", { prefix: "cp2020", target: window, detail: { slugs } })
  }
}
